'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconRectangleLines, iconRectangleLinesTag } from '@ni/nimble-components/dist/esm/icons/rectangle-lines';
import { wrap } from '../../utilities/react-wrapper';

export type { IconRectangleLines };
export { iconRectangleLinesTag };
export const NimbleIconRectangleLines = wrap(IconRectangleLines);